/* Global imports. */
import React from "react";
import { Link } from "gatsby"

interface Props {
  title: string;
  text: string;
  textPlacementClass : string;
  buttonText: string;
  buttonUrl: string;
  imageUrl: string;
  primaryTextColour?: string;
  backgroundColour?: string;
  componentID?: string;
  referringSlug?: string
}

function BannerBackgroundImage({title, text, buttonText, buttonUrl, imageUrl, primaryTextColour, backgroundColour, textPlacementClass, componentID, referringSlug}: Props) {
  const bannerBackgroundImageStyle = {
    backgroundImage: `url(${imageUrl})`,
    backgroundColor: `${backgroundColour}`,
  }

  let textAlignClass = "";

  switch(textPlacementClass) {
    case "banner_text_left":
      textAlignClass = "text-left";
      break;
    case "banner_text_centered":
      textAlignClass = "text-center";
      break;
    case "banner_text_right":
      textAlignClass = "text-right";      
      break;
    default:
      textAlignClass = "text-center";
  }

  const textColour = primaryTextColour ? `text-white sm:text-[${primaryTextColour}]` : "text-white"
  
  return <div id={componentID} data-ref-slug={referringSlug} data-component="banner" className="relative left-[50%] right-[50%] mb-8 ml-[-50vw] mr-[-50vw] max-w-[100vw] w-[100vw]" style={bannerBackgroundImageStyle}>
  <div className="container-main">
    <section className={`flex flex-col flex-wrap w-full pt-24 pb-24  max-w-7xl ${textAlignClass}`}>
      <h1 className={`mb-6 text-2xl sm:text-6xl mx-0 ${textColour}`}>{title}</h1>
      <span className={`mb-6 text-base ${textColour}`} dangerouslySetInnerHTML={{ __html: text }}/>
      {buttonUrl && buttonText && <Link data-title={title} data-componentID={componentID} data-component="banner" to={`${buttonUrl}`} className="ml-0 button !border-0 inline-block">{buttonText}</Link>}
    </section>
  </div>
</div>
}

export default BannerBackgroundImage;